import React from "react";
import Menu from "./Components/Menu";
import Content from "./Components/Content";
import MenuIcon from "@material-ui/icons/Menu";
import { Hidden, Drawer, IconButton } from "@material-ui/core";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { COLOR_BASE, COLOR_HIGH } from "./constants";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: COLOR_BASE,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  menuButton: {
    color: COLOR_HIGH,
    marginLeft: theme.spacing(2),
    height: "60px",
    justifyContent: "left",
    position: "fixed",
    top: "20px",
    left: "10px",
    zIndex: 100,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  drawerPaper: {
    border: "none",
    width: drawerWidth,
  },
}));

const initialScreen = {
  current: "header",
};

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "Rubik",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
});

function screenReducer(state, action) {
  switch (action.type) {
    case "focus":
      return { ...state, current: action.current };
    default:
      return { ...state };
  }
}

function App(props) {
  const { container } = props;
  const classes = useStyles();

  const [screen, dispatch] = React.useReducer(screenReducer, initialScreen);
  const setScreen = (current) => {
    dispatch({ type: "focus", current });
  };

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <nav className={classes.drawer} aria-label="mailbox folders">
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              <Menu
                current={screen.current}
                handleDrawerToggle={handleDrawerToggle}
              />
            </Drawer>
          </Hidden>
          <Hidden smDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              <Menu current={screen.current} />
            </Drawer>
          </Hidden>
        </nav>
        <div className={classes.body}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Content setScreen={setScreen} />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
